import { useSelector } from 'react-redux';
import { selectSingleBatch } from '@reducers/batch';
import { selectServerOffset } from '@reducers/time';

const useManageBatchBlockTime = () => {
  const batch = useSelector(selectSingleBatch);
  const offset = useSelector(selectServerOffset);

  const offsetInSeconds = Math.floor((offset ?? 0) / 1000);

  const timeValue = Math.max((batch?.actualTotalTimeTotalInSeconds || 0) + offsetInSeconds, 0);

  return {
    timeValue,
  };
};

export { useManageBatchBlockTime };
